/* eslint-disable import/no-unresolved */
import { Reducer } from "redux";
import {
  jointMemberInitialValues as jointLifeInitialValues,
  jointMedicalInitialValues as jointLifeMedicalInitialValues
} from "src/helpers/FormDetails/JointLifeAddendum";
import {
  POPULATE_JOINT_PINOCODE_DATA,
  SAVE_JOINT_LIFE_ADDENDUM_DETAILS,
  SET_JOINT_COUNTRY_NAME,
  SET_JOINT_LIFE_ADDENDUM_DETAILS,
  SET_JOINT_REVIEW_DATA,
  SET_JOINT_SUB_OCCUPATION_DATA,
  SET_JOINT_COUNTRY_DATA,
  SET_JOINT_LIFE_COVID_AND_NRI_DETAILS,
  SET_JOINT_LIFE_FREEZE_DATA,
  SAVE_JOINT_MEMBER_ID,
  SET_JOINT_LIFE_ADDENDUM_DETAILS_V2
} from "src/redux/Types/jointLifeDetails";
import { bindJointLifeReviewData } from "src/helpers/FormDetails";
import { JointLifeDetails } from "./interface";

const initialState: JointLifeDetails = {
  member: jointLifeInitialValues.member,
  address: jointLifeInitialValues.address,
  existingPolicy: jointLifeInitialValues.existingPolicy,
  medicalDetails: jointLifeMedicalInitialValues.medicalDetails,
  isAddressProposer: false,
  jointCoBorrowerFlag: false,
  jointGuarantorFlag: false,
  jointPrimaryBorrowerFlag: false,
  jointHousewifeFlag: false,
  covidAndNriDetails: {
    covidTest: {
      covidPositive: false,
      covidQuarantine: "",
      covidComplication: ""
    },
    covidVaccineDates: {
      covidVaccinated: true,
      dateOfFirstDose: "",
      dateOfSecondDose: "",
      dateOfBoosterDose: ""
    },
    nriDetails: {
      currentCountry: "India",
      cityOfResidence: "",
      lastDateOfEntryToIn: "",
      exitDateFromIndia: "",
      durationOfStayAbroad: "",
      purposeOfStayAbroad: "",
      insurancePurpose: ""
    },
    otherCountryTravel: {
      isOtherCountryTravel: false,
      countryName: "india",
      duration: "",
      purpose: ""
    },
    occupationDetails: {
      occupationNameAndRole: ""
    },
    salaried: {
      isSalaried: false,
      companyName: "",
      designation: "",
      currency: "Rupee",
      monthlyIncome: ""
    },
    selfEmployed: {
      isSelfEmployed: false,
      grossTurnover: "",
      annualIncome: ""
    },
    bankDetails: { nameOfTheBank: "", branch: "", accountNumber: "" },
    residence: {
      nameOfTheBankResidence: ""
    },
    policyDetails: {
      isOtherPolicyOutsideIndia: false,
      insurerName: "",
      sumAssured: "",
      premiumAccount: "",
      policyStatus: "",
      dateOfInsurance: ""
    }
  },
  pincodeData: {},
  memberId: "",
  applicationId: "",
  subOccupationData: {},
  countryData: {},
  medicalDetailsV2: {}
};

// eslint-disable-next-line default-param-last
const jointLifeReducer: Reducer<JointLifeDetails> = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_JOINT_LIFE_ADDENDUM_DETAILS: {
      const {
        jointBinding: {
          obj: {
            member,
            address,
            existingPolicy,
            medicalDetails,
            covidAndNriDetails,
            isAddressProposer,
            medicalDetailsV2
          },
          memberId
        },
        leadId
      } = action.payload;
      return {
        ...state,
        member,
        address,
        existingPolicy,
        medicalDetails,
        covidAndNriDetails,
        memberId,
        isAddressProposer,
        applicationId: leadId,
        medicalDetailsV2
      };
    }
    case SET_JOINT_LIFE_ADDENDUM_DETAILS: {
      return { ...state, ...action.payload };
    }
    case SET_JOINT_LIFE_COVID_AND_NRI_DETAILS: {
      return {
        ...state,
        covidAndNriDetails: action.payload
      };
    }
    case POPULATE_JOINT_PINOCODE_DATA: {
      const pincodeResponse = action.payload;
      return { ...state, pincodeData: { [pincodeResponse?.pincode]: pincodeResponse } };
    }
    case SET_JOINT_SUB_OCCUPATION_DATA: {
      const { payload } = action;
      return { ...state, subOccupationData: { [payload?.code]: payload } };
    }
    case SET_JOINT_COUNTRY_NAME: {
      return {
        ...state,
        member: {
          ...state.member,
          ...action.payload
        }
      };
    }
    case SET_JOINT_COUNTRY_DATA: {
      const { payload } = action;
      return { ...state, countryData: { [payload?.code]: payload } };
    }
    case SET_JOINT_REVIEW_DATA: {
      const data = bindJointLifeReviewData(action.payload);
      return {
        ...state,
        ...data
      };
    }
    case SET_JOINT_LIFE_FREEZE_DATA: {
      return {
        ...state,
        member: {
          ...state.member,
          ...action.payload
        }
      };
    }
    case SAVE_JOINT_MEMBER_ID: {
      return {
        ...state,
        memberId: action.payload
      };
    }
    case SET_JOINT_LIFE_ADDENDUM_DETAILS_V2: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default jointLifeReducer;
